import { defineMessages } from 'react-intl';

export const quoteDetailsModalMessages = defineMessages({
  title: {
    id: 'eSVKOw',
    description: 'Title of the quote details modal',
    defaultMessage: 'Quote Details',
  },
  carrierLabel: {
    id: 'EOoiOr',
    description: 'Carrier label in quote details modal',
    defaultMessage: 'Carrier',
  },
  serviceLabel: {
    id: 'Rz8JiO',
    description: 'Service label in quote details modal',
    defaultMessage: 'Service',
  },
  priceLabel: {
    id: 'rYG7v8',
    description: 'Price label in quote details modal',
    defaultMessage: 'Total Charges',
  },
  transitDaysLabel: {
    id: 'qYIYFe',
    description: 'Transit days label in quote details modal',
    defaultMessage: 'Transit Days',
  },
  transitDaysValue: {
    id: 'wgfR7I',
    description: 'Transit days value with pluralization in quote details modal',
    defaultMessage: '{days, plural, one {# day} other {# days}}',
  },
  deliveryDateLabel: {
    id: '0xz5jS',
    description: 'Estimated delivery date label in quote details modal',
    defaultMessage: 'Estimated Delivery',
  },
  guaranteedLabel: {
    id: 'K9Jy7i',
    description: 'Guaranteed label in quote details modal',
    defaultMessage: 'Guaranteed',
  },
  yes: {
    id: 'bM3+Y0',
    description: 'Yes value in quote details modal',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'tYTB/Y',
    description: 'No value in quote details modal',
    defaultMessage: 'No',
  },
  serviceTypeLabel: {
    id: 'GhEZu/',
    description: 'Service type label in quote details modal',
    defaultMessage: 'Service Type',
  },
  insuranceAmountLabel: {
    id: 'PwdQef',
    description: 'Insurance amount label in quote details modal',
    defaultMessage: 'Insured Amount',
  },
  insurancePremiumLabel: {
    id: 'hFUtOn',
    description: 'Insurance premium label in quote details modal',
    defaultMessage: 'Insurance Premium',
  },
  closeButton: {
    id: 'mcFDAC',
    description: 'Close button in quote details modal',
    defaultMessage: 'Close',
  },
});
